import ReactSelect from 'react-select';
import { Image } from '@/shared/ui/image';
import InputMask from 'react-input-mask';

import { WRAPPER } from '@/shared/styles/themes';
import styled from 'styled-components';

export const ImageControl = styled(Image)`
  object-fit: cover;
  position: absolute;
`;

export const OptionCountry = styled.div`
  margin-left: 32px;
`;
export const OptionWrapper = styled.div`
  display: flex;
  padding: 8px 12px 8px 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  margin-bottom: 2px;
  position: relative;
  color: #afafaf;
  cursor: pointer;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 16.8px */
  ${({ $isSelected }) =>
    $isSelected &&
    `
  background: #27262B;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;

  ${OptionCountry} {
      
      color: #EDEFF5;
  }
  
`}

  &:hover ${OptionCountry} {
    color: #edeff5;
  }
  &:hover {
    background: #625a63;
    box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
  }
`;

export const OptionCheck = styled.div`
  position: absolute;
  right: 12px;
  top: 10px;
`;

export const Wrapper = styled.div`
  ${WRAPPER}
  display:flex;
  margin-top: 16px;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const OptionMenu = styled.div`
  border-radius: 8px;
  margin-top: 4px;
  border-radius: 8px;
  min-width: 314px;
  overflow: hidden;
  position: absolute;
  left: -5px;
  background: #3d3c41;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
`;

export const OptionMenuList = styled.div`
  padding: 6px;
`;
export const OptionMenuPortal = styled.div``;

export const Select = styled(ReactSelect)`
  .phone-countries-select__value-container {
    opacity: 0;
  }
  .phone-countries-select__control {
    border-radius: 8px;
    cursor: pointer;
    padding: 8px 10px;
    color: #afafaf;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    border-radius: 8px;
    background: #3d383f;
    width: 70px;
    display: flex;
    flex-wrap: nowrap;
    ${({ $isFocused }) =>
      $isFocused &&
      `
    border-radius: 8px;
    background:#27262B;    
    box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
`}
  }
  .phone-countries-select__menu {
    z-index: 2;
  }
`;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PhoneFieldWrapper = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 16.8px */
  background-color: #3d383f;
  border-radius: 8px;
  border: 1px solid rgba(44, 52, 74, 0.6);
  min-height: 48px;
  padding: 4px;
  width: 100%;

  &:hover {
    background: var(--2-c-344-a-60, rgba(44, 52, 74, 0.6));
  }

  ${({ $error }) => $error && `border: 1px solid #da4444;`}
`;

export const ErrorText = styled.div`
  color: #da4444;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-align: left;
  margin-top: 4px;
`;

export const PhoneInput = styled(InputMask)`
  background: none;
  border: none;
  color: #edeff5;
  width: 100%;
  height: 100%;
  &::placeholder {
    color: rgba(106, 123, 169, 0.6);
  }
`;
export const PhoneInputCode = styled.div`
  background: none;
  border: none;
  color: rgba(106, 123, 169, 0.6);
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
`;

export const MainWrraper = styled.div`
  width: 100%;
`;
